module.exports = __webpack_public_path__ + "img/perrault.381227d3.jpg";